import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import logo from '../images/logo.png';
import { List, ListItem, Typography } from '@mui/material';
import Link from '@mui/material/Link'; // Import the Link component

import '../App.css';
import EyeBallLogo from '../images/eyeball-logo.png';
import HrLogo from '../images/hr-logo.png';
import CmsLogo from '../images/cms-logo.png';
import ClaimsLogo from '../images/claims-logo.png';
import QuotingLogo from '../images/medishure-quoting.png';

function Home() {
    return (
        <Box sx={{ height: '100vh', width: '100vw' }}>
            <AppBar position="sticky" sx={{ background: '#fff', color: '#000', height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', px: '15%', backgroundColor: '#fff' }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                        <Box>
                            <img src={logo} alt="Logo" width="120" height="70" />
                        </Box>

                        <List sx={{ display: 'flex', flexDirection: 'row' }}>
                            <ListItem>
                                <a href='#' className='link'>Home</a>
                            </ListItem>
                            <ListItem>
                                <a href='#' className='link'>Internal</a>
                            </ListItem>
                            {/* <ListItem>
                                <a href='#' className='link'>External</a>
                            </ListItem> */}
                        </List>

                        <Box sx={{ flexGrow: 0 }}>
                            {/* <Button variant="contained" href="\login" sx={{ height: '45px' }}>
                                Login
                            </Button> */}
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', pt: 8 }}>
                <Typography sx={{ textAlign: 'center' }}>
                    <h1>Internal Apps</h1>
                </Typography>
                <Box sx={{ color: '#333', display: 'flex', flexDirection: 'row', gap: 3 }}>
                    <Link href="https://www.mibportal.com/cms" color="inherit" underline="none" sx={{
                        display: 'block',
                        width: '320px',
                    }}>
                        <Box sx={{
                            display: 'block',
                            height: '200px',
                            borderRadius: '5px',
                            boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px;',
                            transition: 'transform 250ms',
                            '&:hover': {
                                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                cursor: 'pointer',
                                transform: 'translateY(-5px)'
                            },
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            p: '30px',
                            background: '#fff'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 2,
                            }}>
                                <img src={CmsLogo} class="cms-logo" alt="" />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography variant='h3' sx={{ fontSize: '19px', fontWeight: 600, mt: 4, textAlign: 'center' }}>
                                    Medishure CMS
                                </Typography>
                                <Typography variant='p' sx={{ fontSize: '16px', fontWeight: 400, color: 'gray', textAlign: 'center' }}>
                                    Commission management system
                                </Typography>
                            </Box>

                        </Box>
                    </Link>
                    <Link href="https://hrms.mibcloud.com/" color="inherit" underline="none" sx={{
                        display: 'block',
                        width: '320px',
                    }}>
                        <Box sx={{
                            display: 'block',
                            height: '200px',
                            borderRadius: '5px',
                            boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px;',
                            transition: 'transform 250ms',
                            '&:hover': {
                                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                cursor: 'pointer',
                                transform: 'translateY(-5px)'
                            },
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            p: '30px',
                            background: '#fff'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center'

                            }}>
                                <img src={HrLogo} class="hr-logo" alt="" />
                            </Box>
                            <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column' }}>
                                <Typography variant='h3' sx={{ fontSize: '19px', fontWeight: 600, mt: 3, textAlign: 'center' }}>
                                    Medishure HR
                                </Typography>
                                <Typography variant='p' sx={{ fontSize: '16px', fontWeight: 400, color: 'gray', textAlign: 'center' }}>
                                    HR management system
                                </Typography>
                            </Box>

                        </Box>
                    </Link>

                    <Link href="https://www.mibportal.com/claims" color="inherit" underline="none" sx={{
                        display: 'block',
                        width: '320px',
                    }}>
                        <Box sx={{
                            display: 'block',
                            height: '200px',
                            borderRadius: '5px',
                            boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px;',
                            transition: 'transform 250ms',
                            '&:hover': {
                                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                cursor: 'pointer',
                                transform: 'translateY(-5px)'
                            },
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            p: '30px',
                            background: '#fff'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <img src={ClaimsLogo} class="claims-logo" alt="" />
                            </Box>
                            <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column' }}>
                                <Typography variant='h3' sx={{ fontSize: '19px', fontWeight: 600, textAlign: 'center' }}>
                                    Medishure Claims
                                </Typography>
                                <Typography variant='p' sx={{ fontSize: '16px', fontWeight: 400, color: 'gray', textAlign: 'center' }}>
                                    Claims management system
                                </Typography>
                            </Box>

                        </Box>
                    </Link>



                </Box>

                {/* <Box sx={{ mt: 5, color: '#333', display: 'flex', flexDirection: 'row', gap: 3 }}>
                    <Link href="https://www.mibportal.com/quoting" color="inherit" underline="none" sx={{
                        display: 'block',
                        width: '320px',
                    }}>
                        <Box sx={{
                            display: 'block',
                            height: '200px',
                            borderRadius: '5px',
                            boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px;',
                            transition: 'transform 250ms',
                            '&:hover': {
                                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                cursor: 'pointer',
                                transform: 'translateY(-5px)'
                            },
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            p: '30px',
                            background: '#fff'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mt: -2.5,
                            }}>
                                <img src={QuotingLogo} class="quoting-logo" alt="" />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography variant='h3' sx={{ fontSize: '19px', fontWeight: 600, textAlign: 'center' }}>
                                    Medishure Quoting
                                </Typography>
                                <Typography variant='p' sx={{ fontSize: '16px', fontWeight: 400, color: 'gray', textAlign: 'center' }}>
                                    Quoting tool system
                                </Typography>
                            </Box>

                        </Box>
                    </Link>
                </Box> */}


            </Box>

            <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: '#333', color: '#fff', py: 2, zIndex: 999 }}>
                <Container maxWidth="xl">
                    <Typography variant="body2" sx={{ textAlign: 'center' }}>
                        &copy; {new Date().getFullYear()} Medishure. All rights reserved.
                    </Typography>
                </Container>
            </Box>
        </Box>
    );
}

export default Home;
